







import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'

@Component({
  components: {}
})
export default class Alert extends Vue {
  get alertShow() {
    return store.state.alert.showAlert
  }

  get alertType() {
    return store.state.alert.alertType
  }

  get alertMessage() {
    return store.state.alert.alertMessage
  }

  get alertBorder() {
    return store.state.alert.alertBorder
  }
}
